import { useState } from "react";

export const useApp = () => {
    const [app, setApp] = useState('tickets'); // tickets | votes
    return [app, setApp];
};

export const useShowCartButton = () => {
    const [showCartButton, setShowCartButton] = useState(false);
    return [showCartButton, setShowCartButton];
};